import React, { useState } from 'react';
import './Hero.css';

export default function Hero() {
  const [searchData, setSearchData] = useState({
    destination: '',
    checkIn: '',
    checkOut: '',
    guests: '2 adults · 0 children · 1 room',
  });

  const handleSearch = (e) => {
    e.preventDefault();
    alert('Connect this to your search API / results page');
  };

  return (
    <div className="hero">
      <div className="hero-inner">
        <h1>Find your next stay</h1>
        <p className="lead">Search low prices on hotels, homes, flights and much more…</p>

        <form className="searchbar" onSubmit={handleSearch}>
          <div className="field">
            <span className="ico">🔍</span>
            <input
              type="text"
              placeholder="Where are you going?"
              value={searchData.destination}
              onChange={(e) => setSearchData({ ...searchData, destination: e.target.value })}
            />
          </div>
          <div className="field">
            <span className="ico">📅</span>
            <div className="colcontent">
              <span className="label">Check-in</span>
              <input
                type="text"
                placeholder="Add date"
                value={searchData.checkIn}
                onChange={(e) => setSearchData({ ...searchData, checkIn: e.target.value })}
              />
            </div>
          </div>
          <div className="field">
            <span className="ico">📅</span>
            <div className="colcontent">
              <span className="label">Check-out</span>
              <input
                type="text"
                placeholder="Add date"
                value={searchData.checkOut}
                onChange={(e) => setSearchData({ ...searchData, checkOut: e.target.value })}
              />
            </div>
          </div>
          <div className="field">
            <span className="ico">👤</span>
            <div className="colcontent">
              <span className="label">Guests</span>
              <input
                type="text"
                placeholder="2 adults · 0 children · 1 room"
                value={searchData.guests}
                onChange={(e) => setSearchData({ ...searchData, guests: e.target.value })}
              />
            </div>
          </div>
          <button type="submit" className="search-btn">
            Search
          </button>
        </form>
      </div>
    </div>
  );
}
